export const PRICING_MODES = ['standard', 'free', 'pay_what_you_want'] as const;

export type PricingMode = (typeof PRICING_MODES)[number];

export const PRICING_MODE_LABELS: Record<PricingMode, string> = {
  standard: 'Fixed price',
  free: 'Free',
  pay_what_you_want: 'Pay what you want',
};

export const PRICING_MODE_DESCRIPTIONS: Record<PricingMode, string> = {
  standard: 'Set a fixed price per seat.',
  free: 'No charge. Enrollment goes through the standard flow with no payment required.',
  pay_what_you_want: 'Students choose their own amount. You can set a suggested price.',
};

export function isPricingMode(value: string | null | undefined): value is PricingMode {
  return typeof value === 'string' && (PRICING_MODES as readonly string[]).includes(value);
}
